// import React, { useState } from 'react'
import React from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import MultiSessionInput from 'components/multi-session-input'
import { useFormContext } from 'react-hook-form'
// import YesNoButtons from '../form-components/yes-no-buttons'

// TODO: Re-implement once recurring events are implemented
// const MultiSessionEventDayTimeRedesign = () => {
//   const [isYes, setIsYes] = useState(false)

//   return (
//     <Container maxWidth="md" xs={12}>
//       <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
//         <Box mb={2}>
//           <Typography variant="h4" align="center">
//             Is your offer recurring?
//           </Typography>
//         </Box>
//         <Box mb={8}>
//           <Typography variant="body1" align="center">
//             Recurring offerings are those that occur on a regular basis at the
//             same time, such as the first Saturday of every month at 10:00 am, or
//             weekly on Wednesdays at 6:00 pm.
//           </Typography>
//         </Box>
//         <Box mb={8}>
//           <YesNoButtons {...{ isYes, setIsYes }} />
//         </Box>
//         <Typography variant="h6" align="center">
//           Set the date and time for your offering.
//         </Typography>
//       </Box>
//       {/* {isYes ? () : ()} */}
//       <MultiSessionInput name="sessions" />
//     </Container>
//   )
// }

const MultiSessionEventDayTimeRedesign = ({ facilities }) => {
  const { getValues } = useFormContext()
  const selectedFacilityId = getValues('locationId')
  const selectedFacility = facilities?.find(
    facility => facility.id === selectedFacilityId,
  )
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          What day(s) do you want to host this offering?
        </Typography>
      </Box>
      <Container maxWidth="md" xs={12}>
        <MultiSessionInput
          name="sessions"
          timezone={selectedFacility?.timezone}
        />
      </Container>
    </Box>
  )
}

export default MultiSessionEventDayTimeRedesign
